import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import DemoBanner from './components/DemoBanner';
import DemoWelcome from './components/demo/DemoWelcome';
import DemoGuide from './components/demo/DemoGuide';
import DemoOutbox from './components/demo/DemoOutbox';
import { captureReferral } from './lib/referral';
import './App.css';

export default function App() {
  useEffect(() => {
    const savedTheme = localStorage.getItem('pi-portal-theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
    // Referral attribution: record ?ref= / utm_* from the landing URL
    // (first touch, 30-day window). See src/lib/referral.js.
    captureReferral();
  }, []);

  // Guest video visits (/visit/<token>) are for outside visitors with no
  // account — the demo chrome (welcome role-picker, banner, mascot, outbox)
  // must not cover or clutter their call. Guests always arrive by full page
  // load, so a mount-time pathname check is reliable here (these components
  // live outside the router and can't use useLocation).
  const isGuestVisit = window.location.pathname.startsWith('/visit/');

  return (
    <>
      <RouterProvider router={router} />
      {!isGuestVisit && (
        <>
          <DemoBanner />
          <DemoWelcome />
          <DemoGuide />
          <DemoOutbox />
        </>
      )}
    </>
  );
}
